import { Component } from "@angular/core";
import { slideToBottomTransition } from "../../animations";
import { Angulartics2 } from "angulartics2";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { switchMap } from "rxjs";

@Component({
  templateUrl: "./request-invite.component.html",
  animations: [slideToBottomTransition],
})
export class RequestInviteComponent {
  tool: string;
  inviteSent: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private angulartics2: Angulartics2
  ) {}

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          // Here you can add logic if needed before assigning the tool
          this.tool = params.get("tool");
          return this.tool; // Or handle as needed
        })
      )
      .subscribe((result) => {
        // Handle results if needed
        console.log("Tool updated:", this.tool);
      });
  }

  requestInvite() {
    this.angulartics2.eventTrack.next({
      action: "Request an invite",
      properties: {
        tools: this.tool,
      },
    });
    this.inviteSent = true;
  }
}
